import axios from 'axios'

// axios.defaults.headers.common['Cache-Control'] =
//   'private, no-cache, no-store, must-revalidate'
// axios.defaults.headers.common['Expires'] = 0
// axios.defaults.headers.common['Pragma'] = 'no-cache'
// axios.defaults.headers.common['If-Modified-Since'] =
//   'Mon, 26 Jul 1997 05:00:00 GMT'

export const AWS_HTTP = axios.create({
  baseURL: 'https://8cbbcmqpi9.execute-api.us-west-2.amazonaws.com/dev/',
  headers: {}
})

// export const AWS_HTTP = axios.create({
//   baseURL: 'https://3azxoq20el.execute-api.us-west-2.amazonaws.com/Prod/',
//   headers: {}
// })

export function log(msg, isError, source) {
  AWS_HTTP.post('log', {
    log: msg + (source ? ' (' + source + ')' : ''),
    error: isError
  }).catch(e => {
    console.log(msg + (source ? ' (' + source + ')' : ''))
    console.log(e)
  })
}
